import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=3aba3a44&scoped=true&"
import script from "./personalCenter.vue?vue&type=script&lang=js&"
export * from "./personalCenter.vue?vue&type=script&lang=js&"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=3aba3a44&lang=less&scoped=true&"
import style1 from "./personalCenter.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aba3a44",
  null
  
)

export default component.exports